<template>
  <div class="container">
    <div class="home">
      
      <h3 class="slideUp ad0 copy copy-hi">Hey there, I'm</h3>
      <h1 class="slideUp ad1 copy copy-name">KEYHAN <span class="lastname">Akbarzadeh</span></h1>
      <h2 class="slideUp ad2 copy copy-title"><span>$</span> UI/UX Designer &amp; Front-end Developer <span class="indicator">|</span></h2>
      <h3 class="slideUp ad3 copy copy-platform">Web . Android . iOS</h3>
      <div class="slideUp ad4 icons">
        <div class="icon">
          <font-awesome-icon icon="code" />
        </div>
        <div class="icon">
          <font-awesome-icon :icon="['fab', 'android']" />
        </div>
        <div class="icon">
          <font-awesome-icon :icon="['fab', 'apple']" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'home',
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  overflow: hidden;
}
</style>
